// Copyright (c) Docugami, Inc. All rights reserved.

import { useEffect, useState } from "react";
import { ComponentId } from "sdv/engine/Component";
import { Engine } from "sdv/engine/Engine";
import { Entity } from "sdv/engine/Entity";

interface ISdvEntityQuery {
    entities: Entity[];
}

export const useSdvEntityQuery = (components: ComponentId[], engine: Engine | null): ISdvEntityQuery => {
    const [entities, setEntities] = useState<Entity[]>([]);

    useEffect(() => {
        if (!engine) {
            return;
        }

        const onChanged = () => {
            setEntities([...query.entities])
        }

        const query = engine.sdvInterface.entities.query(components);
        onChanged();

        const unregisterAdded = query.entityAdded.addListener(onChanged);
        const unregisterRemoved = query.entityRemoved.addListener(onChanged);

        return () => {
            unregisterAdded();
            unregisterRemoved();
            setEntities([]);
        }
    }, [engine, components]);

    return {
        entities: entities
    }
}
